<div class="card">
    <app-header titulo="Materiais" descricao="Integrações do cadastro de material. (ERP > PIMS)"></app-header>
    <p-table [value]="materiais" dataKey="id" #dt [loading]="loading" [globalFilterFields]="['cdItemErp','cdItemPims','cdGrupoErp','deItem','cdUnidadeErp','dtIntegPims']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
        <ng-template pTemplate="caption">
            <div class="flex justify-content-end flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem"
                        [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                            placeholder="Pesquisar" />
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getMateriais()"
                        [loading]="loading"></button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Cód. Erp</th>
                <th>Cód. PIMS</th>
                <th>Grupo ERP</th>
                <th>Descrição</th>
                <th>Unidade ERP</th>
                <th>Integrado?</th>
                <th>Data Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-material>
            <tr>
                <td>{{ material.cdItemErp }}</td>
                <td>{{ material.cdItemPims }}</td>
                <td>{{ material.cdGrupoErp }}</td>
                <td>{{ material.deItem }}</td>
                <td>{{ material.cdUnidadeErp }}</td>
                <td><app-tag-status [status]="material.fgStatusInteg"></app-tag-status></td>
                <td>{{ material.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ material.deMensagemInteg }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="7">Não há materiais integrados</td>
        </ng-template>
    </p-table>
</div>